module.exports = __webpack_public_path__ + "img/icon-table-check.6c337c8f.svg";